import {useRef} from "react";
import {TextArea} from "../../input";
import RenderIf from "../../render-if";
import Typo from "../../typo";
import Button from "../../button";
import __ from "../../../utils/translate/translate";
import {useGetComment, usePostComment} from "../api/comment";
import handleError from "../../../helper/handelError";
import {getJalaliDate} from "../../../utils/date";
import {CommentCard} from "../../card";
import {useAuthContext} from "../../../../feature/Auth/provider/AuthProvider";

const SendComment = ({id, type, isForce = false}) => {
    const {user} = useAuthContext()
    const refInputs = {
        comment: useRef(null),
    };
    let data = {}
    if (type === "news") {
        data = {post_id: id}
    }
    if (type === "mission") {
        data = {mission_id: id}
    }


    const {mutate, reset: resetMutation, isLoading, isSuccess} = usePostComment();
    const {
        data: myComment,
        refetch
    } = useGetComment(data)

    const handleSend = () => {
        mutate(
            {
                comment: refInputs.comment.current.getValue(),
                is_force: isForce,
                ...data
            },
            {
                onSuccess: () => {
                    refInputs.comment.current.reset();
                    refetch();
                },
                onError: (error) => {
                    handleError(error)
                }
            }
        );
    };

    const hasComment = !!myComment?.data?.id;
    const showForm = !hasComment
    return (
        <>
            <RenderIf cond={hasComment}>
                <CommentCard
                    id={myComment?.data?.id}
                    name={myComment?.data?.user?.firstName + " " + myComment?.data?.user?.lastName}
                    comment={myComment?.data?.comment}
                    teamName={myComment?.data?.owner?.team?.name}
                    location={myComment?.data?.owner?.city?.displayName}
                    avatar={myComment?.data?.user?.avatarDetail?.url}
                    createdAt={getJalaliDate(myComment?.data?.createdAt)}
                    isMine={myComment?.data?.user?.id === user?.id}
                    refetch={() => {
                        refetch()
                        resetMutation()
                    }}
                />
            </RenderIf>
            <RenderIf cond={showForm}>
                <div className="flex flex-col items-end gap-2">
                    <TextArea
                        className="w-full"
                        name={__("send.input")}
                        label={__("Write your comment")}
                        required
                        rules={[{rule: "minLength", cond: 2}]}
                        maxLength={2000}
                        ref={refInputs.comment}
                    />
                    <RenderIf
                        cond={!isSuccess}
                        falsyElement={
                            <Typo size="xs" type="success" className="rounded-full bg-green/10 px-2">
                                {__("Your comment created successfully.")}
                            </Typo>
                        }
                    >
                        <Button onClick={handleSend} isLoading={isLoading} scale="fit">
                            {__("Send comment")}
                        </Button>
                    </RenderIf>
                </div>
            </RenderIf>
        </>
    );
};

export default SendComment;
